import { render, staticRenderFns } from "./rusak_keluar.vue?vue&type=template&id=9c9a8c22&"
import script from "./rusak_keluar.vue?vue&type=script&lang=js&"
export * from "./rusak_keluar.vue?vue&type=script&lang=js&"
import style0 from "./rusak_keluar.vue?vue&type=style&index=0&id=9c9a8c22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports